import * as React from 'react';
export const FunctionsContext = React.createContext(() => {});